import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import api from "@/lib/api";
import { waLink } from "@/lib/site";

export default function Faqs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 pb-24" data-testid="faqs-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <SectionHeading overline="FAQs" title={<>Questions? <span className="font-light italic">Answered.</span></>} className="mb-12" />
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-white border border-border rounded-2xl px-6 overflow-hidden">
                <AccordionTrigger data-testid={`faq-question-${i}`} className="hover:no-underline py-5 text-left font-semibold">{f.q}</AccordionTrigger>
                <AccordionContent className="text-ink/60 text-sm leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.15} className="mt-12 text-center">
          <p className="text-ink/60 mb-4">Still curious about something?</p>
          <a href={waLink("Hi click2trip! I have a question.")} target="_blank" rel="noreferrer" data-testid="faq-whatsapp-btn"
            className="inline-flex bg-[#25D366] text-white font-semibold px-8 py-3.5 rounded-full hover:bg-[#1fb857] transition-colors">
            Ask on WhatsApp
          </a>
        </Reveal>
      </div>
    </div>
  );
}
